import { render } from "./sleepingarea-2.vue?vue&type=template&id=0c4ea5c6&scoped=true"
import script from "./sleepingarea-2.vue?vue&type=script&lang=js"
export * from "./sleepingarea-2.vue?vue&type=script&lang=js"

import "./sleepingarea-2.vue?vue&type=style&index=0&id=0c4ea5c6&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4ea5c6"]])

export default __exports__